export enum OfferPriceType {
  CustomPrice = 'customPrice',
  NoPrice = 'noPrice',
  Cheap = 'cheap',
  Medium = 'medium',
  Expensive = 'expensive',
}

// price types to set/update in DB
export const mainOfferPriceTypes: OfferPriceType[] = [
  OfferPriceType.Cheap,
  OfferPriceType.Medium,
  OfferPriceType.Expensive,
];

export const offerPriceTypeLabels = {
  [OfferPriceType.CustomPrice]: 'Custom price',
  [OfferPriceType.NoPrice]: 'No price',
  [OfferPriceType.Cheap]: 'Cheap',
  [OfferPriceType.Medium]: 'Medium',
  [OfferPriceType.Expensive]: 'Expensive',
};
